import userCenter from "./userCenter/index.js";
export default [...userCenter];
